import * as React from 'react';
import * as styles from './PromoCard.css';

interface IPromoCardProps {
  image: React.ReactNode;
  moreInfo: React.ReactNode;
  menu: React.ReactNode;
  disclaimer?: React.ReactNode;
}

export function PromoCard({ image, moreInfo, menu, disclaimer }: IPromoCardProps) {
  return (
    <article className={styles['container']} data-testid="PromoCard">
      <div className={styles['image']}>{image}</div>
      <div className={styles['more']}>{moreInfo}</div>
      <div className={styles['menu']}>{menu}</div>
      {disclaimer && (
        <div data-testid="PromoCardDisclaimer" className={styles['disclaimer']}>
          {disclaimer}
        </div>
      )}
    </article>
  );
}
